import { View, Text } from "react-native";
import React from "react";
import { useSelector } from "react-redux";

export default function Vu(props) {
  const main = useSelector((store) => store.main);
  return (
    <View {...props} dir={main.rtl ? "rtl" : "ltr"}>
      {props.children}
    </View>
  );
}
